<section class="contact-page-area section-gap">

  <div style="height: 50px"></div>
  <div class="w-100">
    <div class="map-wrap" style="color: rgba(255, 255, 255, 0.595)" id="data">

      <p style="text-align: right" *ngIf="document.documentElement.dir == 'rtl'">
        تاکسی دیدار تحت عنوان شرکت دیدار شهر آشنا در سال 1385 توسط مرحوم مهندس
        محمود محمودی فر در خیابان نیکبخت غربی راه اندازی شد. از همان نخست، مشتری
        مداری سرلوحه کار این شرکت بوده است که توانسته است در طول سالیان مجموعه
        ای از مشتریان خانگی، موسسات، بانک ها، ادارات دولتی و شرکت های خصوصی را
        به مجموعه مشترکین خود بیافزاید.
        <br />
        در مهر 1392 پس از درگذشت مهندس محمود محمودی فر، مدیریت شرکت به پسر ایشان
        آقای آرمان محمودی فر واگذار گردید. در این دوره تغییرات زیادی در نحوه کار
        ایجاد شد که شامل:
        <br /><br />
        1- راه اندازی سیستم کامپیوتری با دارا بودن نرم افزار تاکسی سرویس و
        پایگاه داده مشتریان و کرایه مسیرهای مختلف.
        <br />
        2- سیستم کالرآیدی که به محض تماس مشترکین، نام و آدرس آنها بر روی مانیتور
        نمایش داده می شود و مشتری نیاز به بیان آدرس مبدا و نام خویش ندارد. این
        سیستم کمک به دقیق شدن و کوتاه شدن زمان دریافت سفارش سرویس می کند.
        <br />
        3- نصب پرینتر حرارتی برای چاپ قبض سرویس. برای هر سرویس یک قبض چاپ می شود
        که تمامی مشخصات سرویس که شامل نام مسافر، مبدا، مقصد، کرایه و نام راننده
        در آن می باشد. این قبض متعلق به مسافر می باشد.
        <br />
        4- ارسال پیامک CRM برای آگاهی از درصد رضایت مشتری از سرویس انجام شده.
        <br />
        5- راه اندازی وب سایت جهت رزو کردن سرویس به طور آنلاین، دریافت پیام های
        مشترکین و ...
        <br />
        <br />
        تغییرات اخیر:
        <br />
        - در سال 1398 نام شرکت به دیدار آشنا شهر زیبا تغییر یافت.
        <br />
        - در مرداد1399 شرکت به خیابان مصلی، ابتدای کوچه رضایی جابه جا شد.
        <br />
        <br />
        هدف: مدیریت شرکت امیدوار است که همواره با ارایه سرویس های خوب و با
        استفاده از تکنولوژی روز به عنوان شرکت حمل و نقل درون شهری برتر شهر
        اصفهان شناخته شود.
        <br />
        <br />

        مدیر عامل
        <br />
        آرمان محمودی فر
      </p>
      <p style="text-align: left" *ngIf="document.documentElement.dir == 'ltr'">
        Didar taxi, Didar Shahr Ashna Company, was established by Mr. Mahmoud
        Mahmoudifar after his retirement to provide urban transportation in 2007
        in West Nikbakht St, Esfahan. Since the beginning, customer satisfaction
        has been the main goal of this company. Therefore, this company has been
        able to expand its customers to different categories including
        governmental organizations, private companies, offices, schools, homes
        etc during these years.
        <br /><br />
        Sadly, Engineer Mahmoud Mahmoudifar passed away in 2013. Hence, the
        management of the company has been handed over to his son, Arman
        Mahmoudifar. Since then, our services have been improved in many ways
        including:
        <br /><br />
        1- Computerizing the process of service providing including using
        dedicated software for urban transportation, customer database, tracking
        the car etc.
        <br />
        2- Using a Caller ID system linked to the customer database in the
        computer to be more accurate and shorten the time takes to order a
        service by a customer.
        <br />
        3- Installing a Thermal Receipt Printer to print the service receipt
        including the following information: name and address of customer, name
        of driver, destination and its fare.
        <br />
        4- Running a Customer Relation Management (CRM) system to assess our
        services by customers, find our deficiencies and eliminate them.
        <br />
        5- Launching the website for online ordering instead of calling, having
        better relation with our customers, advertising etc.
        <br /><br />
        Recent changes:
        <br />
        - In 2019, company’s name has been changed to Didar Ashnashahr Ziba
        Company.
        <br />
        - In August 2020, the company’s place moved to Mosalla St. with keeping
        the same contact number.
        <br /><br />
        Our goal: Management of the company hopes to evolve the company to be a
        leading company in the field of urban transportation through providing
        excellent services and using modern technologies.
        <br /><br />
        Arman Mahmoudifar.
      </p>
    </div>
  </div>
  <div class="h-100"></div>
</section>
